<template>
  <md-card>
    <slot name="title"></slot>
    <md-card-content class="md-layout md-alignment-center-left">
      <slot></slot>
    </md-card-content>
    <md-card-actions>
      <slot name="actions"></slot>
    </md-card-actions>
  </md-card>
</template>

<script>
export default {
  name: "FilterBar",

  props: {
    title: {
      type: String,
      default: "Filtros",
    },
  },

  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.md-card {
  margin: 0;
  .md-card-header {
    padding-top: 0;
    padding-bottom: 0;
    margin-bottom: -12px;
  }
  .md-card-content {
    justify-content: space-between;
    // padding: 0 10px;
  }
  .md-card-actions {
    display: flex;
    justify-content: flex-end; /* Corregido */
    padding: 0 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FilterBar.vue